<!--公司信息界面-->
<template>
	<div>
		<p style="margin-top: 25px;">电力公司总数 : <span style="color: #00C6FF;font-size: 18px;">{{companyCount}}</span></p>
		<div class="flexBetween" style="margin-top: 16px;">
			<p style="font-size: 16px;color: #80BFEC;text-align: center;width: 50%;">电力服务公司</p>
			<p style="font-size: 16px;color: #80BFEC;text-align: center;width: 50%;">电力制造公司</p>
		</div>
		<div class="flexBetween" style="height: calc(100% - 90px);">
			<div class="custom-scrollbar hideBar" style="height: 100%;width: 50%;">
				<p v-for="item in serviceCompanyList" class="leftCompanyListP" @click="showDialog(item, '电力服务公司')">{{item}}</p>
			</div>
			<div class="custom-scrollbar hideBar" style="height: 100%;width: 50%;">
				<p v-for="item in makeCompanyList" class="leftCompanyListP" @click="showDialog(item, '电力制造公司')">{{item}}</p>
			</div>
		</div>
		
		<infoDialog v-show="isShow" :isShow="isShow" :title='title' :nowUnit="nowUnit" @closeDialog="isShow = false"></infoDialog>
		
	</div>
</template>

<script>
	import infoDialog from '@/page/projectDingZhi/Ubiquitous/infoDialog.vue'
	
	export default {
		components: {
			infoDialog
		},
		props: {},
		data() {
			return {
				companyCount: 0,
				serviceCompanyList: [],
				makeCompanyList: [],
				isShow: false,
				nowUnit: {},
				title: ''
			}
		},
		created() {},
		mounted() {
			var axios = require('axios')
			axios({
				url: "/static/中科泛在定制/看板/数据/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				//公司信息
				this.companyCount = data.companyInfo.companyCount
				this.serviceCompanyList = data.companyInfo.serviceCompanyList
				this.makeCompanyList = data.companyInfo.makeCompanyList
				this.nowUnit = data.companyInfo.nowUnit
			})
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			showDialog(item, title){
				this.title = title
				this.nowUnit['name'] = item
				this.isShow = true
			}
		}
	}
</script>

<style scoped>
	.leftCompanyInfo p {
		color: white;
		text-align: center;
		font-weight: 500;
	}

	.leftCompanyListP {
		width: 100%;
		height: 13px;
		font-size: 14px;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 40px;
		margin-bottom: 20px;
		text-align: center;
	}
</style>
